import { Member } from '@ffx/common';

export type MemberState = {
    currentProjectUsers: Member[];
    membersLoading: boolean;
    leaveProjectLoading: boolean;
    projectId: string;
    memberAdded: boolean;
};

export const initialState: MemberState = {
    currentProjectUsers: [],
    membersLoading: false,
    leaveProjectLoading: false,
    projectId: '',
    memberAdded: false
};
